(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  function initLoadMore(section) {
    const button = section.querySelector('.load-more-btn');
    if (!button || button.dataset.initialised === '1') return;
    button.dataset.initialised = '1';

    const grid = section.querySelector('.product-grid');

    const loadMore = async function () {
      if (button.classList.contains('is-loading') || button.style.display === 'none') return;

      const handle = button.dataset.collectionHandle;
      const perPage = parseInt(button.dataset.perPage, 10) || 4;
      const currentPage = parseInt(button.dataset.page, 10) || 1;
      const total = parseInt(button.dataset.total, 10) || 0;
      const nextPage = currentPage + 1;

      button.classList.add('is-loading');
      button.disabled = true;

      try {
        const url = '/collections/' + encodeURIComponent(handle) + '?view=product-cards&page=' + nextPage;
        const response = await fetch(url, { headers: { 'Accept': 'text/html' } });
        if (!response.ok) throw new Error('Network response was not OK (' + response.status + ')');
        const html = await response.text();

        const temp = document.createElement('div');
        temp.innerHTML = html.trim();
        const items = temp.querySelectorAll('.product-item');

        items.forEach(function (item) { grid.appendChild(item); });

        button.dataset.page = nextPage;

        const loadedSoFar = nextPage * perPage;
        if (items.length === 0 || items.length < perPage || loadedSoFar >= total) {
          button.style.display = 'none';
          if (scrollObserver) scrollObserver.disconnect();
        }
      } catch (e) {
        console.error('[custom-collection-product-grid] Load more failed:', e);
      } finally {
        button.classList.remove('is-loading');
        button.disabled = false;
      }
    };

    button.addEventListener('click', loadMore);

    // Auto-trigger the same load-more flow whenever the button scrolls near
    // the viewport. Unlike the theme's native "infinite" pagination (see
    // LoadMoreButton in assets/facets.js), which gets a brand-new button
    // element — and therefore a fresh observer — on every page load, this
    // section keeps reusing the SAME button across loads. FoxTheme.Motion.inView
    // only fires once per element, so after the first auto-load it would never
    // fire again even though the same button re-enters the viewport on later
    // scrolls. A self-managed IntersectionObserver that stays connected (until
    // the button is hidden/exhausted above) fixes that.
    var scrollObserver = null;
    if ('IntersectionObserver' in window) {
      scrollObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadMore();
          });
        },
        { rootMargin: '200px 0px 200px 0px' }
      );
      scrollObserver.observe(button);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function(section){
      initLoadMore(section);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function mount(container) {
      if (!container) return;
      var tpl = container.querySelector('template.pdp-similar-products-deferred');
      if (!tpl) return;
      container.appendChild(tpl.content.cloneNode(true));
      container.removeAttribute('data-lazy-mount');
      tpl.remove();
    }

    function setup(container) {
      if (!container || container.dataset.lazyMount !== 'true') return;
      if (!('IntersectionObserver' in window)) {
        mount(container);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            mount(container);
            io.disconnect();
            return;
          }
        }
      }, { rootMargin: '300px' });
      io.observe(container);
    }

    function setupAll(root) {
      (root || document).querySelectorAll('.tabs__panels[data-lazy-mount="true"]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setupAll(); });
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      setupAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
